import { queryOptions } from "@tanstack/react-query";

import { apiFetch } from "../lib/api";
import type {
  CompletenessResponse,
  ProjectDetailResponse,
  ProjectListResponse,
  ProjectRescanResponse,
  TimelineResponse,
} from "./types";

export const projectsQueryOptions = queryOptions({
  queryKey: ["projects"],
  queryFn: () => apiFetch<ProjectListResponse>("/projects"),
});

export const projectCompletenessQueryOptions = (projectId: string) =>
  queryOptions({
    queryKey: ["projects", projectId, "completeness"],
    queryFn: () =>
      apiFetch<CompletenessResponse>(`/projects/${projectId}/completeness`),
  });

export const projectDetailQueryOptions = (projectId: string) =>
  queryOptions({
    queryKey: ["projects", projectId, "detail"],
    queryFn: () => apiFetch<ProjectDetailResponse>(`/projects/${projectId}`),
  });

export const projectTimelineQueryOptions = (projectId: string) =>
  queryOptions({
    queryKey: ["projects", projectId, "timeline"],
    queryFn: () =>
      apiFetch<TimelineResponse>(`/projects/${projectId}/timeline`),
  });

export function requestProjectRescan(
  projectId: string,
): Promise<ProjectRescanResponse> {
  return apiFetch<ProjectRescanResponse>(`/projects/${projectId}/rescan`, {
    method: "POST",
  });
}
